import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { SAVED_SEARCHES_QUERY_KEY } from './useSavedSearchesQuery';

interface DeleteSavedSearchParams {
	searchId: string;
	impersonationContext?: Api.IImpersonationContext;
}

interface UseDeleteSavedSearchMutationOptions {
	onSuccess?: () => void;
	onError?: (error: unknown) => void;
}

export function useDeleteSavedSearchMutation({ onSuccess, onError }: UseDeleteSavedSearchMutationOptions = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ searchId, impersonationContext }: DeleteSavedSearchParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `contactSearch/${encodeURIComponent(searchId)}`,
					impersonationContext,
				}),
				'DELETE'
			);
		},
		onSuccess: () => {
			// Invalidate the saved searches list query
			queryClient.invalidateQueries({
				queryKey: [SAVED_SEARCHES_QUERY_KEY],
			});
			onSuccess?.();
		},
		onError: error => {
			onError?.(error);
		},
	});
}
